import { AppProps, StateSlice } from "../..";

export type MenuListProps = {
  menuList: {
    selectedCategory: string | null;
  };
};

export type MenuListState = MenuListProps & {
  menuList: {
    setSelectedCategory: (value: string | null) => void;
  };
};

export const defaultMenuListProps: MenuListProps = {
  menuList: {
    selectedCategory: null,
  },
};

export const createMenuListState: (props?: Partial<AppProps>) => StateSlice<MenuListState> =
  (props) => (set) => ({
    menuList: {
      ...defaultMenuListProps.menuList,
      ...props?.menuList,
      setSelectedCategory: (value: string | null) =>
        set((state: MenuListState) => ({
          ...state,
          menuList: {
            ...state.menuList,
            selectedCategory: value,
          },
        })),
    },
  });
